import styled from "styled-components";

export const HistoryContainer = styled.div``;

export const Header = styled.div`
  padding: 12px 28px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  row-gap: 10px;
  background: var(--filter-bar-bg);
  .filter-icon {
    p {
      color: #fff;
    }
    svg {
      path {
        fill: #fff;
      }
    }
  }
  
  .label-wrapper {
    .label {
      font-size: 13px;
      line-height: 16px;
      white-space: nowrap;
      color: var(--theme-text);
    }
  }
  .refresh-btn {
    background-color: var(--input-background);
    border: 1px solid var(--border-color);
    border-radius: 6px;
    width: 30px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  > div {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 0 10px;
    border-left: 1px solid #cdcfd0;
    svg {
      cursor: pointer;
    }
    :first-child {
      border: none;
    }
  }
  @media (max-width: 850px) {
    &.display {
      display: none;
    }
    background: transparent;
    padding: 0;
    > div {
      border: none;
    }
  }
`;

export const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  input {
    background: #ffffff;
    border: 1px solid #cdcfd0;
    border-radius: 6px;
    padding-left: 10px;
    min-height: 30px;
    width: 100px;
  }
  img {
    position: absolute;
    right: 8px;
  }
`;

export const Container = styled.div`
  background-color: #fafcff;
  padding: 0 28px 22px;
  max-height: calc(100vh - 120px);
  overflow: auto;
  @media (max-width: 1547px) {
    max-height: calc(100vh - 148px);
  }
`;

export const HistoryTableInnerSection = styled.div`
  width: 100%;
  height: calc(100vh - 128px);
  overflow: auto;
  &.no-pagination{
    .MuiDataGrid-footerContainer {
      display: none !important;
    }
  }
  .word-wrap{
    white-space: normal !important;
    word-break: break-word !important;
  }
  .inner-div {
   p {
    display: flex;
    align-items: center;
    gap: 5px;
   }
  }
  .super-time-theme--cell {
    display: flex;
    align-items: center;
    gap: 5px;
    color: var(--text-primary);
    opacity: 0.5;
    font-weight: 500;
  }
  .action-btn {
    .round-btn {
      border-color: var(--border-color);
      color: var(--text-primary);
    }
  }
  .table-btn-wrapper {
    padding: 0;
  }
  .text-cell-inner-data {
    .show-more-btn {
      display: none;
    }
  }
  .MuiDataGrid-virtualScrollerRenderZone {
      > .MuiDataGrid-row {
        > div {
          .cars-cell {
          span {
            display: inline-flex;
            align-items: center;
          }            
          }
        }
      }
    }
    .inner-dot-add {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      p {
        white-space: normal;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .MuiDataGrid-row > div .cars-cell {
      display: flex !important;
      align-items: center !important;
      gap: 6px !important;
      overflow: visible !important;
      min-height: 24px !important;
    }

    .MuiDataGrid-row > div .cars-cell svg {
      width: 24px !important;
      height: 24px !important;
      display: inline-block !important;
      overflow: visible !important;
    }
      
  @media (max-width: 1195px) {
    max-height: calc(100vh - 170px);
  }
 @media (max-width: 850px) {
  .MuiDataGrid-root {
    width: 100% !important;
  }

  .MuiDataGrid-main,
  .MuiDataGrid-virtualScrollerRenderZone,
  .MuiDataGrid-columnHeadersInner {
    min-width: max-content !important; /* allowing horizontal scroll */
  }

  .cars-cell {
    overflow: visible !important;
    position: relative !important;
    z-index: 1 !important; /* brings content to front */
    
    > span, > div {
      overflow: visible !important;
      white-space: nowrap !important;
    }
  }
  
  .MuiDataGrid-row {
    > div {
      :nth-child(2) {
        overflow: visible !important;
        position: relative !important; 
        z-index: 2 !important; 
      }
    }
  }
  
  .MuiDataGrid-cell {
    position: relative !important; 
    z-index: 0 !important; 
  }

  .dot-add,
  .inner-dot-add {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }

  .show-more-btn {
    display: flex;
    border: none;
    background-color: transparent;
    font-weight: 600;
    font-size: 12px;
    line-height: 150%;
    color: #00a692;
    text-decoration: underline;
    padding: 0;
  }

  .MuiDataGrid-virtualScroller::-webkit-scrollbar {
    width: 12px;
    height: 12px;
  }
  .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 6px;
  }
  .MuiDataGrid-virtualScroller::-webkit-scrollbar-track {
    background-color: transparent;
  }
}
`;
